import React, { useState } from "react";
import Select from "react-select";
import AppButton from "@/components/buttons/AppButton";
import { BUTTONS, GLOBAL_ORGANIZATION } from "@/utils/constants/appConstants/commonConstants";
import { setCurrentOrganization } from "@/utils/functions/OrganizationFunctions";
import { errorToasterMessage } from "@/utils/functions/toaster";
import { getName } from "@/utils/functions/TokenFunction";

interface SelectOrganizationProps {
    handleOrganization: any;
}

const orgSelectStyles = {
    placeholder: (provided: Record<string, unknown>) => ({ ...provided, textAlign: "left" as const }),
    option: (provided: Record<string, unknown>) => ({ ...provided, textAlign: "left" as const }),
    singleValue: (provided: Record<string, unknown>) => ({ ...provided, textAlign: "left" as const }),
    control: (provided: Record<string, unknown>) => ({ ...provided, textAlign: "left" as const }),
    menu: (provided: Record<string, unknown>) => ({ ...provided, textAlign: "left" as const }),
};

const SelectOrganization = (props: SelectOrganizationProps) => {
    const userName = getName();
    const data = localStorage.getItem("organizations");
    const organizations = JSON.parse(data as string);

    const [err, setErr] = useState("");
    const [loading, setLoading] = useState(false);
    const [selectedOrganization, setSelectedOrganization] = useState<{ label: string; value: string } | null>(null);
    const [currentOrg, setCurrentOrg] = useState("");

    const orgOptions =
        organizations
            ?.filter((org: any) => org.is_active)
            .map((org: any) => ({
                label: org.name === GLOBAL_ORGANIZATION ? "Personal" : org.name,
                value: org.organization,
            })) ?? [];

    const handleOrganizationChange = (selectOrg: { label: string; value: string } | null) => {
        setSelectedOrganization(selectOrg);
        setCurrentOrg(selectOrg?.value ?? "");
        setErr("");
    };

    const handleUserOrganization = (e: React.FormEvent) => {
        e.preventDefault();
        if (!currentOrg) { setErr("Please select an organization"); return; }
        const currentOrganization = organizations.filter((org: any) => org.organization === currentOrg);
        setCurrentOrganization(currentOrganization[0]);
        setLoading(true);
        props.handleOrganization(
            currentOrg,
            () => { setLoading(false); },
            (error: any) => { setLoading(false); errorToasterMessage(error?.response?.data?.message); },
            setErr
        );
    };

    return (
        <div className="mb-5">
            <form method="POST" onSubmit={handleUserOrganization}>
                <div className="mb-4">
                    <label className="text-sm font-medium text-foreground mb-1 block capitalize" htmlFor="org-select">
                        Hi, {userName}
                    </label>
                    <Select
                        inputId="org-select"
                        className="gs-login-org-select mt-2"
                        classNamePrefix="react-select"
                        styles={orgSelectStyles}
                        value={selectedOrganization}
                        options={orgOptions}
                        onChange={handleOrganizationChange}
                        placeholder="Select organization"
                        isClearable
                    />
                    {err && <p className="text-destructive text-xs mt-1">{err}</p>}
                </div>
                <div>
                    <AppButton
                        id="select-org-next-btn"
                        isLoading={loading}
                        btnText={BUTTONS.NEXT}
                        className="btn-lg btn-block btn-primary"
                        type="submit"
                    />
                </div>
            </form>
        </div>
    );
};

export default SelectOrganization;
